import React from "react";
import { object, array, number, string, bool } from "prop-types";
import { Link } from "@quintype/components";
import CardImage from "../../atoms/cardimage";
import Headline from "../../atoms/headline";
import StoryDate from "../../atoms/story-date";

import "./story-card10.m.css";

const StoryCard10 = ({
  story,
  aspectRatio,
  imageType,
  headerType,
  headerLevel,
  showVideoIcon = true,
  showDate = true
}) => {
  return story ? (
    <div className="story-card story-card-10" styleName="story-card-10" id="story-card-10">
      <Link href={`/${story.slug}`} styleName="video-wrapper">
        <CardImage
          story={story}
          aspectRatio={aspectRatio}
          imageType={imageType}
          widths={[320]}
          sizes="(max-width: 1024px) 100vw, 50vw"
          showVideoIcon={showVideoIcon}
        />
      </Link>
      <Link href={`/${story.slug}`} className="headline-link">
        <Headline text={story.headline} headerType={headerType} headerLevel={headerLevel} story={story} />
      </Link>
      {showDate && <StoryDate story={story} />}
    </div>
  ) : null;
};

StoryCard10.defaultProps = {
  aspectRatio: [16, 9],
  imageType: "image16x9",
  headerType: 7,
  headerLevel: 3,
  showVideoIcon: true,
  showDate: true
};

StoryCard10.propTypes = {
  story: object.isRequired,
  aspectRatio: array,
  imageType: string,
  headerType: number,
  headerLevel: number,
  showVideoIcon: bool,
  showDate: bool
};

export default StoryCard10;
